import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
const TabPageLayout = ({ title, subtitle, actions, stats, filters, children }) => {
    return (_jsxs(LayoutContainer, { children: [(title || subtitle) && (_jsxs(HeaderSection, { children: [title && _jsx(PageTitle, { children: title }), subtitle && _jsx(PageSubtitle, { children: subtitle })] })), stats && _jsx(StatsSection, { children: stats }), actions && _jsx(ActionsSection, { children: actions }), filters && _jsx(FiltersSection, { children: filters }), _jsx(ContentSection, { children: children })] }));
};
// Styled Components
const LayoutContainer = styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 0;
`;
const HeaderSection = styled.div `
    margin-bottom: 1.5rem;
    min-height: 60px;

    @media (max-width: 768px) {
        margin-bottom: 1rem;
        min-height: 50px;
    }

    @media (max-width: 375px) {
        margin-bottom: 0.75rem;
        min-height: 40px;
    }
`;
const PageTitle = styled.h2 `
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--text-primary, #1a1a1a);
    margin: 0 0 0.5rem 0;

    @media (max-width: 768px) {
        font-size: 1.25rem;
    }

    @media (max-width: 375px) {
        font-size: 1.1rem;
    }
`;
const PageSubtitle = styled.p `
    color: var(--text-secondary, #666);
    font-size: 0.9rem;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 0.85rem;
    }

    @media (max-width: 375px) {
        font-size: 0.8rem;
    }
`;
const StatsSection = styled.div `
    margin-bottom: 1.5rem;
    min-height: 0;

    @media (max-width: 768px) {
        margin-bottom: 1rem;
    }

    @media (max-width: 375px) {
        margin-bottom: 0.75rem;
    }
`;
const ActionsSection = styled.div `
    margin-bottom: 1.5rem;
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-wrap: wrap;
    min-height: 44px;

    @media (max-width: 768px) {
        margin-bottom: 1rem;
        gap: 0.75rem;
    }

    @media (max-width: 375px) {
        margin-bottom: 0.75rem;
        gap: 0.5rem;
    }
`;
const FiltersSection = styled.div `
    margin-bottom: 1.5rem;
    min-height: 0;

    @media (max-width: 768px) {
        margin-bottom: 1rem;
    }

    @media (max-width: 375px) {
        margin-bottom: 0.75rem;
    }
`;
const ContentSection = styled.div `
    flex: 1;
    min-height: 0;
`;
export default TabPageLayout;
